/**
 * Service: analyticsApi
 */
angular.module('acme.common.service.analyticsApi', [])
.service('AnalyticsApiService', ['$http', function($http) {

  return {

    service: '',

    init: function (endpoint) {
      this.service = endpoint + '/analytics';
      this.revenue.service = endpoint + '/analytics/revenue';
      this.report.service = endpoint + '/analytics/report';
      this.report.config.service = this.report.service + '/config';
      return this;
    },


    report: {
      service: '',

      config: {
        service: '',

        datasources: function () {
          return $http({
            url: this.service + '/datasourcenames'
          });
        },

        getFields: function (datasource) {
          return $http({
            url: this.service + '/fields/' + datasource
          });
        },

        updateFields: function(props) {
          return $http({
            method: 'post',
            url: this.service + '/fields',
            data: {
              dataSourceName: props.dataSourceName,
              fieldNames: props.fieldNames
            }
          });
        }

      }

    },
    revenue: {
      service: '',

      detail: function(props) {
        var q = [],
            query = '';

        if (props.sortOrder) {
          q.push('sortOrder='+props.sortOrder);
        }

        if (props.startTime) {
          q.push('startTime='+props.startTime);
        }

        if (props.endTime) {
          q.push('endTime='+props.endTime);
        }

        if (props.limit) {
          q.push('limit='+props.limit);
        }else{
          q.push('limit=5');
        }

        if (q.length > 0) {
          query = '?' + q.join('&');
        }

        return $http({
          method: 'get',
          url: this.service + query
        });
      },

      summary: function(date) {
        return $http({
          method: 'get',
          url: this.service + '/summary?date=' + date
        });
      }

    }

};

}]);